import { useTranslation } from 'i18n';
import { Box, Typography } from 'ui';

export const NoDocument = () => {
  const { t } = useTranslation('orders');

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
        p: 4,
      }}
    >
      <Typography variant="h4" align="center">
        {t('documentGeneration.documentDetails.notFound')}
      </Typography>
    </Box>
  );
};
